/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import UserList from './UserList';

export default function Users(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <UserList />
      </MainLayout>
    </div>
  );
}
